// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CLMandatoryFieldMarker-module__mandatory_field_marker___ft_VW{color:var(--cl_color_error)}`, "",{"version":3,"sources":["webpack://./CLMandatoryFieldMarker.module.scss"],"names":[],"mappings":"AAAA,+DACE,2BAAA","sourcesContent":[".mandatory_field_marker {\n  color: var(--cl_color_error);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mandatory_field_marker": `CLMandatoryFieldMarker-module__mandatory_field_marker___ft_VW`
};
export default ___CSS_LOADER_EXPORT___;
